// Project-specific configuration for map colors and styling

export const mapBgColours = {
    // Original colors
    'positive': '#28a745',     // Green for positive wealth growth
    'negative': '#dc3545',     // Red for negative wealth growth
    'neutral': '#6c757d',      // Gray for neutral

    // Total R&R Index colors (gradient from #F5F6F7 to #405363)
    'total_excellent': '#405363',    // Darkest (highest ranking)
    'total_good': '#7B8995',         // Dark
    'total_fair': '#A5ADB5',         // Medium
    'total_poor': '#D0D3D7',         // Light
    'total_critical': '#F5F6F7',     // Lightest (lowest ranking)

    // Risk colors (gradient from lighter to #920000)
    'risk_excellent': '#FFCCCC',     // Lightest (lowest risk)
    'risk_good': '#FF9999',          // Light
    'risk_fair': '#FF6666',          // Medium
    'risk_poor': '#CC3333',          // Dark
    'risk_critical': '#920000',      // Darkest (highest risk)

    // Resilience colors (gradient from #FFF to #008B25)
    'resilience_excellent': '#008B25', // Darkest (most resilient)
    'resilience_good': '#33A447',      // Dark
    'resilience_fair': '#66BD69',      // Medium
    'resilience_poor': '#99D68B',      // Light
    'resilience_critical': '#CCEFAD',  // Lightest (least resilient)

    // Legacy rank colors
    'rank_type_1': '#405363',
    'rank_type_2': '#536472',
    'rank_type_3': '#667582',
    'rank_type_4': '#798691',
    'rank_type_5': '#8C98A1',
    'rank_type_6': '#9FA9B1',
    'rank_type_7': '#B3BAC1',
    'rank_type_8': '#C5CBD0',
    'rank_type_9': '#D9DDE0',
    'rank_type_10': '#ECEDEF',

    // Visa colors
    'visa_free_access': '#39AC4A',
    'visa_on_arrival': '#53C14A',
    'electronic_travel_authorisation': '#83D87A',
    'visa_online': '#F66662',
    'visa_required': '#CB172B'
};

// Global Resilience Index metrics configuration
export const resilienceConfig = {
    riskMetrics: [
        { key: 'inflationRisk', label: 'Inflation Risk' },
        { key: 'currencyVolatility', label: 'Currency Volatility' },
        { key: 'politicalStability', label: 'Political Instability' },
        { key: 'legalRegulatory', label: 'Legal and Regulatory Risk' },
        { key: 'physicalClimateRisk', label: 'Physical Climate Risk' }
    ],
    resilienceMetrics: [
        { key: 'economicComplexity', label: 'Economic Complexity' },
        { key: 'externalAccounts', label: 'External Accounts' },
        { key: 'investment', label: 'Investment' },
        { key: 'innovation', label: 'Innovation' },
        { key: 'qualityOfGovernance', label: 'Quality of Governance' },
        { key: 'socialProgress', label: 'Social Progress' },
        { key: 'fiscalCapacity', label: 'Fiscal Policy Space' },
        { key: 'climateResilience', label: 'Climate Resilience' }
    ],
    colors: {
        risk: '#920000',          // Total Risk Score
        riskDetail: '#640000',    // Risk Indicators
        resilience: '#008B25',    // Total Resilience Score
        resilienceDetail: '#005818' // Resilience Indicators
    },
    labels: {
        risk: 'Total Risk Score (Out of 100)',
        resilience: 'Total Resilience Score (Out of 100)'
    }
};
